import AiClientForm from "@/src/components/AiClientForm"
import { GlobalBanner } from '../../components/upload/GlobalBanner'

interface OrganizationUploadProps {
  organization: any
  globalBannerColor: string
  onProcessingIdsChange: (ids: string[]) => void
}

export function OrganizationUpload({ organization, globalBannerColor, onProcessingIdsChange }: OrganizationUploadProps) {
  const orgBannerHtml = organization?.bannerText

  return (
    <>
      {orgBannerHtml && (
        <GlobalBanner html={orgBannerHtml} color={globalBannerColor} />
      )}
      <div className="mb-4 flex justify-center items-center gap-4">
        {organization?.logo ? (
          <img
            src={organization.logo}
            alt={`${organization.name} Logo`}
            className="select-none h-24 w-auto object-contain"
          />
        ) : (
          <div className="text-4xl font-bold text-foreground">
            {organization?.name}
          </div>
        )}
      </div>
      <AiClientForm onProcessingIdsChange={onProcessingIdsChange} />
    </>
  )
}
